import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const WithTooltip = (title) => {
    return (
        <div
            className="ellipsis"
            title={title}
        >
            {title}
        </div>
    );
};
export const WithIcon = (title, icon) => {
    return (
        <div title={title}>
            <FontAwesomeIcon icon={icon} />
        </div>
    );
};
